module.exports = __webpack_public_path__ + "static/media/logoTakeatClube.a0f73edd.png";